// extracted by mini-css-extract-plugin
export var cardBg = "event-session-cards-module--card-bg--87469";
export var listSummitAgenda = "event-session-cards-module--list-summit-agenda--6487b";
export var summitTagCustomersOnly = "event-session-cards-module--summit-tag-customers-only--46d45";
export var summitTagHighlight = "event-session-cards-module--summit-tag-highlight--5b782";
export var summitTags = "event-session-cards-module--summit-tags--ca71b";